export default function dataArrayDelete(data){
    // [{way,index}]
    const akce = {
        type: "DATADELETE",
        data:data
    }
    this.dataDispatch(akce)
}